exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body.addFocusOutline ._3X058h7HKxkBn6gH63VmN-:focus{outline:none!important}", ""]);

// exports
exports.locals = {
	"focusableItem": "_3X058h7HKxkBn6gH63VmN-"
};